// extracted by mini-css-extract-plugin
export default {"infoContainer":"info-and-value_infoContainer__L8uYi"};